import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Button, Table, Tag, Select, Pagination } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-regular-svg-icons";
import ShopPopup from "./popup";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";
import Notification from "../../services/Notification";
import PaymentPopup from "./payment";

const List = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openPaymentPopUp, setOpenPaymentPopUp] = useState(false);
  const [details, setDetails] = useState();
  const [name, setName] = useState();
  const [pageDetails, setPageDetails] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(1);
  const [updatedAt, setUpdatedAt] = useState();
  const [sort, setSort] = useState();
  const timerId = useRef(null);

  const columns = [
    {
      title: "Studio Name",
      dataIndex: "name",
    },
    {
      title: "Shop No",
      dataIndex: "shopNumber",
    },
    {
      title: "Phone No",
      dataIndex: "phone",
    },
    {
      title: "Price Type",
      dataIndex: "priceType",
      render: (tags) => <Tag color={"green"}>{tags}</Tag>,
    },
    {
      title: "Pending Amount",
      dataIndex: "pendingAmount",
      sorter: true,
    },
    {
      title: "Points",
      dataIndex: "points",
    },
    {
      title: "Pay",
      dataIndex: "pendingAmount",
      render: (text, record) => (
        <Tag
          role="button"
          color="#87d068"
          onClick={() => {
            setDetails(record);
            setOpenPaymentPopUp(true);
          }}
        >
          Pay
        </Tag>
      ),
    },
    {
      title: "Status",
      dataIndex: "active",
      render: (text, record) => (
        <>
          <Tag
            role="button"
            color={record.active === false ? "#f50" : "#87d068"}
            onClick={() => {
              updateStatus(record);
            }}
          >
            {record.active ? "ACTIVATE" : "DEACTIVATE"}
          </Tag>
          <FontAwesomeIcon
            role="button"
            icon={faEdit}
            onClick={() => {
              setDetails(record);
              setOpenPopup(true);
            }}
          />
        </>
      ),
    },
  ];

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await axios
          .get("/shop-list", {
            params: {
              limit,
              page,
              name,
              sort,
            },
          })
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });
        if (data && data.data) {
          setPageDetails(data.data.data);
          setCount(data.data.count);
          setLoading(false);
        }
      } catch (error) {
        Helper.ErrorHanlder(error);
      }
    })();
  }, [limit, page, updatedAt, name, sort]);

  function closeModelPopup(data) {
    setOpenPopup(false);
    setOpenPaymentPopUp(false);
    if (data) {
      setUpdatedAt(Date.now());
      Notification.success(`${details ? "Updated" : "Created"} Successfully`);
    }
  }

  const updateStatus = async (details) => {
    try {
      let obj = { id: details.id, active: !details.active };
      const data = await axios.post("/shop-create", obj).catch((error) => {
        Helper.ErrorHanlder(error);
      });
      if (data && data.data) {
        setUpdatedAt(Date.now());
        Notification.success("Status updated successfully");
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  const handlePageChange = (value) => {
    setPage(1);
    setLimit(value);
  };

  const handleChange = (pagination, filters, sorter) => {
    const offset =
      pagination.current * pagination.pageSize - pagination.pageSize;
    const limit = pagination.pageSize;
    let params = {};

    if (sorter.hasOwnProperty("column")) {
      params = { field: sorter.field, dir: sorter.order };
    }
    setPage(1);
    setSort(params);

    //getData(offset, limit, params);
  };

  return (
    <Container>
      <Row>
        <Col md={12}>
          <div className="shop-pg">
            <div className="deactive-btn">
              <Button
                type="primary"
                className="addnew-btn"
                onClick={(e) => {
                  setDetails("");
                  setOpenPopup(true);
                }}
              >
                Add New
              </Button>
            </div>
            <div className="input-group search">
              <input
                type="text"
                className="form-control search-input-box mb-3 mt-3"
                placeholder="Search by studio Name"
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </div>
            <Table
              columns={columns}
              dataSource={pageDetails}
              pagination={false}
              onChange={handleChange}
              loading={loading}
              rowKey="id"
            />
            <div className="pagination">
              <Select
                defaultValue={limit}
                style={{ width: 120 }}
                onChange={handlePageChange}
                options={[
                  {
                    value: 5,
                    label: "5",
                  },
                  {
                    value: 10,
                    label: "10",
                  },
                  {
                    value: 20,
                    label: "20",
                  },
                  {
                    value: 25,
                    label: "25",
                  },
                ]}
              />
              {loading === false && (
                <Pagination
                  defaultCurrent={page}
                  pageSize={limit}
                  showSizeChanger={false}
                  total={count}
                  onChange={setPage}
                />
              )}
            </div>
          </div>
        </Col>
      </Row>
      {openPopup && (
        <ShopPopup show={openPopup} close={closeModelPopup} details={details} />
      )}
      {openPaymentPopUp && (
        <PaymentPopup
          show={openPaymentPopUp}
          close={closeModelPopup}
          details={details}
        />
      )}
    </Container>
  );
};

export default List;
